module.exports = __webpack_public_path__ + "img/s2.fb052488.webp";